<template>
  <div>
    <breadcrumb/>
    <post-list category="BBEE Productos y Servicios - Leasing"></post-list>
  </div>
</template>

<script>
import PostList from "@/components/Posts/PostList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    PostList,
    Breadcrumb
  }
};
</script>